module.exports = __webpack_public_path__ + "img/horizontal_6_7_6005.844ed9b0.png";